import { Typography, AppBar, Toolbar, Box, IconButton } from "@mui/material";
import { FC, useEffect, useMemo, useRef, useState } from "react";
import { usePathname, useRouter } from "next/navigation";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import VirusSelector from "@/context/virusSelector";
import MaintenanceBanner from "./banners/MaintenanceBanner";

export const HEADER_HEIGHT_CSS_VAR = "--header-height";
export const HEADER_HEIGHT = `var(${HEADER_HEIGHT_CSS_VAR}, 48px)`;

export const Header: FC = () => {
  const pathname = usePathname();
  const router = useRouter();
  const [currentPage, setCurrentPage] = useState("");
  const headerRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const header = headerRef.current;
    if (!header) return;
    const root = document.documentElement;
    const observer = new ResizeObserver(() =>
      root.style.setProperty(HEADER_HEIGHT_CSS_VAR, `${header.offsetHeight}px`),
    );
    observer.observe(header);
    return () => {
      observer.disconnect();
      root.style.removeProperty(HEADER_HEIGHT_CSS_VAR);
    };
  }, []);

  // Fonction pour capitaliser la première lettre et remplacer les underscores par des espaces
  const formatPageName = (name: string) => {
    const formattedName = name.replace(/_/g, " "); // Remplacer les underscores par des espaces
    return formattedName.charAt(0).toUpperCase() + formattedName.slice(1);
  };

  useEffect(() => {
    // Récupérer la partie de l'URL après le premier slash et la formater
    const pageSegment = pathname?.split("/")[1];
    setCurrentPage(
      pageSegment
        ? formatPageName(pageSegment)
        : "ARBOGEN - Advancing ARBOvirus research through large-scale GENomic tracking",
    );
    if (pathname?.split("/")[1] === "explore") {
      setCurrentPage("Visualize & Explore");
    } else if (pathname?.split("/")[1] === "contribute") {
      setCurrentPage("Share & Contribute");
    } else if (pathname?.split("/")[1] === "import_for_dataset") {
      setCurrentPage("Add Arbogen ID to dataset (from New Import)");
    } else if (pathname?.split("/")[1] === "sequence_for_dataset") {
      setCurrentPage("Add Arbogen ID to dataset (from Existing Sequences)");
    }
  }, [pathname]);

  const showBackButton = useMemo(() => {
    if (!pathname) return false;
    const parts = pathname.split("/").filter(Boolean);
    const isDatasetId = !isNaN(Number(parts[1]));
    return parts[0] === "datasets" && parts.length > 1 && isDatasetId;
  }, [pathname]);

  const handleBack = () => {
    if (typeof window !== "undefined" && window.history.length > 1) {
      router.back();
    } else {
      router.replace("/datasets/mine");
    }
  };

  return (
    <AppBar position="fixed" ref={headerRef}>
      <MaintenanceBanner />
      <Toolbar variant="dense" sx={{ paddingRight: "0px !important" }}>
        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            alignItems: "center",
            ml: "288px", // keep title start aligned with drawer width
            position: "relative",
          }}
        >
          {showBackButton && (
            <IconButton
              size="small"
              aria-label="Go back"
              onClick={handleBack}
              sx={{
                color: "inherit",
                position: "absolute",
                left: -36, // place inside the left margin area without shifting the title
                top: "50%",
                transform: "translateY(-50%)",
              }}
            >
              <ArrowBackIosNewIcon />
            </IconButton>
          )}
          <Typography variant="h6">{currentPage}</Typography>
        </Box>

        <Box sx={{ ml: "auto", position: "relative" }}>
          <VirusSelector />
          {/* <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "transparent",
              zIndex: 10,
            }}
          /> */}
        </Box>
      </Toolbar>
    </AppBar>
  );
};
